import { create } from 'zustand';

interface ChatSidebarCollapsedState {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

export const useChatSidebarCollapsed = create<ChatSidebarCollapsedState>(
  (set) => ({
    isCollapsed: false,
    setIsCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
  })
);
